export interface IFoxtrotEventData {
	source: string;
	events: {
		eventName: string;
		eventTime: number;
		data: Record<string, unknown> | undefined;
	}[];
	orderType: string;
	transactUrl: string;
}
export type TEventType = 'custom' | 'click' | 'pageview' | 'error' | 'apiError';

export enum GarfieldCommands {
	SEND = 'send',
	CREATE = 'create',
	SET = 'set',
}

export interface IGarfieldDataConfig {
	eventName: string;
	value?: unknown;
	additionalData?: Record<string, unknown>;
}

export interface IGarfieldEventSchema {
	eventType: TEventType;
	eventData: IGarfieldDataConfig;
}

export interface IGarfieldEventPayload {
	eventType: TEventType;
	eventName?: string;
	value?: unknown;
	data?: Record<string, unknown>;
}

export enum RedirectCallMode {
	POST = 'POST',
	REDIRECT = 'REDIRECT',
}

export interface IRedirectResponse {
	callMode: RedirectCallMode;
	redirectUrl: string;
	notificationResponse?: Record<string, string>;
}
